import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'


const AreaChart = ({
    chartLabel,
    chartData = [],
    xField,
    yField,
    fieldsLabel = "",
    tooltipFields = [],
    height = 420,
    areaColor = "#0EA5E9",
    purpose = "",
    legendLabel = "",
    yAxisTitle='',
    xAxisTitle=''
}) => {

    const graphData =
        chartData.length > 0
            ? chartData
            : [];

    const option = {
        tooltip: {
            trigger: "axis",
            formatter(params) {
                const item = graphData[params[0].dataIndex];
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }
                html += `<b>${item[xField]}</b><br/>`;
                tooltipFields.forEach(field => {
                    html += `<b>${field.label}</b> : ${item[field.key] ?? "-"}<br/>`;
                });

                return html;
            },
        },
        legend: {
            show: !!legendLabel,
            top: 5,
            left: "center",
            icon: "roundRect",
            itemWidth: 18,
            itemHeight: 10,
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
            data: [legendLabel],
        },

        grid: {
            left: "8%",
            right: "4%",
            top: "8%",
            bottom: "12%",
            containLabel: true,
        },

        xAxis: {
            type: "category",
            boundaryGap: false,
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 60, 
            data: graphData.map(item => item[xField]),
            axisTick: {
                show: false,
            },
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 30,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            splitLine: {
                show: false,
            },
        },

        yAxis: {
            type: "value",
            show: true,
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 35,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            splitLine: {
                lineStyle: {
                    color: "#E5E7EB",
                },
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            }
        },

        series: [
            {
                name: legendLabel || yField,
                type: "line",
                smooth: true,
                symbol: "circle",
                symbolSize: 8,
                data: graphData.map(item => item[yField]),
                lineStyle: {
                    color: areaColor,
                    width: 4,
                },
                itemStyle: {
                    color: areaColor,
                },
                areaStyle: {
                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            {
                                offset: 0,
                                color: "rgba(14,165,233,.35)",
                            },
                            {
                                offset: 1,
                                color: "rgba(14,165,233,.05)",
                            },
                        ],
                    },
                },
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            fields={fieldsLabel}
            height={height}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default AreaChart;